import { Controller } from '@hotwired/stimulus'

// Дата и время начала в форме матча (account/matches/new.slim): на сегодня
// прошедшие получасы недоступны. «Сегодня» и «сейчас» считаются в том же
// поясе, в котором сервер разберёт время (UserMatch#match_time_zone): в поясе
// выбранного города (его сообщает match_city_controller.js событием
// match-city:picked), а без города — в поясе устройства. Иначе форма из
// Лондона для матча в Хельсинки предлагала бы уже прошедшие там получасы.
// Сервер проверяет то же самое (UserMatch#starts_in_future), здесь — чтобы
// прошедшее время просто нельзя было выбрать. Список пересчитывается при
// открытии формы, смене даты и города; если форма простоит открытой и полчаса
// пройдёт до отправки, время отклонит сервер (форма вернётся с сообщением).
export default class MatchStartController extends Controller {
  static targets = ['date', 'time', 'zone']
  static values = { cityZone: String }

  connect() {
    // Пояс устройства: по нему сервер разберёт время матча без города.
    this.zoneTarget.value ||=
      new Intl.DateTimeFormat().resolvedOptions().timeZone
    this.sync()
  }

  cityPicked({ detail: { timeZone } }) {
    this.cityZoneValue = timeZone || ''
    this.sync()
  }

  sync() {
    this.dateTarget.min = this.today()
    const select = this.timeTarget.querySelector('select')
    const isToday = this.dateTarget.value === this.today()
    const now = this.nowTime()

    let changed = false
    Array.from(select.options).forEach((option) => {
      if (option.hasAttribute('data-placeholder')) return
      const disabled = isToday && option.value <= now
      if (option.disabled !== disabled) changed = true
      option.disabled = disabled
    })

    // Выбранное раньше время стало прошедшим (сменили дату на сегодня) —
    // сбрасываем на плейсхолдер, а не оставляем недоступное значение.
    // Плейсхолдер тоже disabled — его не считаем.
    const selected = select.selectedOptions[0]
    if (selected?.disabled && !selected.hasAttribute('data-placeholder')) {
      select.value = ''
      changed = true
    }

    // Перерисовываем список, только если набор доступных получасов поменялся.
    if (changed) this.timeTarget.dispatchEvent(new Event('select:refresh'))
  }

  // Дата и время «сейчас» в поясе матча: [ 'YYYY-MM-DD', 'HH:MM' ].
  zonedNow() {
    const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }
    if (this.cityZoneValue) options.timeZone = this.cityZoneValue

    let parts
    try {
      parts = new Intl.DateTimeFormat('en-CA', options).formatToParts(
        new Date()
      )
    } catch {
      // Незнакомый браузеру пояс города — считаем по устройству.
      delete options.timeZone
      parts = new Intl.DateTimeFormat('en-CA', options).formatToParts(
        new Date()
      )
    }
    const part = (type) => parts.find((p) => p.type === type).value
    return [
      `${part('year')}-${part('month')}-${part('day')}`,
      `${part('hour')}:${part('minute')}`
    ]
  }

  today() {
    return this.zonedNow()[0]
  }

  nowTime() {
    return this.zonedNow()[1]
  }
}
